import {AUTHENTICATION_CONFIGURATION_NAMES} from '@core/services/auth/authenticationConfigNames';

export const environment = {
  production: false,
  serverUrl: 'https://app-hfgconnect-api-dev.azurewebsites.net/api',
  envName: 'dev',
  loggingLevel: 3,
  navbarBgClass: 'bg-sqeptech',
  clientLogoAsset: 'sqeptech_connect_icon.png',
  clientLogoAsset2: 'sqeptech_connect_icon.png',
  heading: 'SQEPtech - Connect (Dev)',
  subTitle: 'Integration Management',
  loginPageMessage: '',
  shareUrl: '',
  idle: 100000,
  time_out: 100000,
  clientAccount: {
    menu: 'default',
  },
  auth: [
    {
      authConfigName: AUTHENTICATION_CONFIGURATION_NAMES.CSOD,
      enabled: false,
      buttonTitle: 'Login with Cornerstone',
      logoutUrl: '',
      spConfigName: '',
    },
    {
      authConfigName: AUTHENTICATION_CONFIGURATION_NAMES.OKTA,
      enabled: false,
      buttonTitle: 'Login with Okta',
      clientId: '',
      openIdIssuer: '',
      sqeptechClientId: '',
      sqeptechOpenIdIssuer: '',
      allowedOrigins: [],
    },
    {
      authConfigName: AUTHENTICATION_CONFIGURATION_NAMES.ENTRA,
      enabled: true,
      buttonTitle: 'Login with SSO',
      clientId: 'd31fa3ae-a9fc-43f4-92d7-7310a4773c4e', // dev client
      allowedAzureTenants: ['d320fce4-2119-4307-8597-5b2363fcc067'],
    },
  ],
};
